import React, { FC } from "react";
import styles from "./index.module.scss";
import { IReviewCardProps } from "types/components/common/reviewCard";
import { lifeChoiseDetailsDesktop } from "constantVariables";
import Image from "components/common/Image";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import ReadMore from "components/ReadMore";
import useMediaQuery from "hooks/useMediaQuery";
import RatingStar from "assets/icons/RatingStar";
import { t } from "i18next";

const ReviewCard: FC<IReviewCardProps> = ({
  className,
  item: {
    placeholder_auther: { name, image },
    content,
    rating,
    year,
    company,
  },
  title,
  cardType,
}) => {
  const { dir, language } = useAppSelector(getSettings);
  const isDesktop = useMediaQuery(lifeChoiseDetailsDesktop);
  return (
    <div
      className={`${styles["review-card"]} p-4 lg:p-6  ${
        className ? styles[className] : ""
      }`}
      dir={dir}
      lang={language}
    >
      <div className={"flex item-center gap-4 lg:gap-6"}>
        {image ? (
          <Image
            src={process.env.REACT_APP_CLOUDFRONT_URL + image + '.jpg' || ""}
            className="min-h-[74px] min-w-[74px] max-h-[74px] max-w-[74px] rounded-full object-cover"
          />
        ) : (
          <div className="min-h-[74px] min-w-[74px] max-h-[74px] max-w-[74px] rounded-full bg-theme-purple flex items-center justify-center">
            <h2 className="text-white text-2xl font-heebo">
              {name.split(" ").map((n) => n[0])}
            </h2>
          </div>
        )}
        <div className="flex flex-col justify-center">
          <h3 className={`text-lg font-bold text-black`}>
            {name}
          </h3>

          {cardType === "careerCard" && (
            <h5
              lang={language}
              dir={dir}
              className={`${styles["career-card-company"]}
              text-sm font-light
              `}
            >
              {title && title[language]} | {company}
            </h5>
          )}

          {cardType === "overviewCard" && (
            <p className={`text-sm lg:text-base m-0 text-black`}>
              {t("graduated") as string} {year}
            </p>
          )}
        </div>
      </div>
      <p className={`${styles["content"]} | margin-block-start-200`}>
        <ReadMore charactersToPreview={150} lang={language} dir={dir}>
          {content[language]}
        </ReadMore>
      </p>
      <div dir={dir} className="flex items-center gap-2">
        {new Array(rating).fill(0).map((_, idx) => (
          <RatingStar key={_} className="fill-[#F29423] lg:fill-theme-purple" />
        ))}
      </div>
    </div>
  );
};

export default ReviewCard;
